/* istanbul ignore file */
import { useFieldHelper } from 'framework/ui/field';
import { FormFieldsData } from 'framework/form';
import { SearchResultAttachmentsListField } from 'domain/shared/artifact/field';

type ArtifactStorageFileFieldProps = {
  label?: string;
  source: string;
  value?: string;
  isVisible?: boolean | ((values: FormFieldsData) => boolean);
};

const ArtifactStorageFileField = (props: ArtifactStorageFileFieldProps) => {
  const { getValue } = useFieldHelper<any>(props);
  const file = getValue() || {};

  return <SearchResultAttachmentsListField {...props} key={file.id} value={[file.id]} />;
};

export default ArtifactStorageFileField;
